// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.screenfull-svg[data-v-43afc372] {\r\n  width: 17px;\r\n  height: 17px;\r\n  cursor: pointer;\r\n  fill: #606266;\r\n  vertical-align: middle;\r\n  margin-right: 15px;\n}\r\n", ""]);
// Exports
module.exports = exports;
